const extraterrestrial_solar_radiation_table = {
    lat: {
        "41": [14.4, 20, 27, 34.4, 39.5, 41.8, 40.9, 36.8, 30.3, 22.9, 16.3, 13.1], 
    },
};
export default extraterrestrial_solar_radiation_table;